import { render, staticRenderFns } from "./PrintModeColorSelect.vue?vue&type=template&id=c04744fc&scoped=true"
import script from "./PrintModeColorSelect.vue?vue&type=script&lang=js"
export * from "./PrintModeColorSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04744fc",
  null
  
)

export default component.exports